class ProductVariants extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    async initSwiper() {
      const swiperEl = this.querySelector('.product-variants__slider');
      if (!swiperEl) return;

      // Find the index of the active slide
      const slides = swiperEl.querySelectorAll('.swiper-slide');
      let activeIndex = 0;

      slides.forEach((slide, index) => {
        if (slide.querySelector('.product-variants__image-container.active')) {
          activeIndex = index;
        }
      });

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 3.2,
        spaceBetween: 4,
        initialSlide: activeIndex,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          640: {
            slidesPerView: 3.2,
          },
          1024: {
            slidesPerView: 4,
          },
        },
      });
    }
  }

  customElements.define('product-variants', ProductVariants);